import React from 'react'

const BodyCheck = () => {
	return <div></div>
}

export default BodyCheck
